import { ViewportScroller } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { States } from 'app/_models/constants';
import { PermitsService } from 'app/forests/services/permits.service';
import { WindowRef } from 'app/_services/native-window.service';
import CustomValidators from 'app/shared/custom-validators';
import { FeedbackService } from 'app/_services/feedback.service';
import { ModalService } from 'app/shared/modal/modal.service';
import { FeedbackDto } from '@system-shared/classes.dto';

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    standalone: false
})
export class FeedbackComponent implements OnInit {
  feedbackForm: FormGroup;
  productQuantities: number[] = [];
  permitExpirationDate: any = {
    expDateShort: '',
    expDateLong: ''
  };
  states = States;
  fullName: string;
  idOtherDescriptionRequired = false;
  forest: any = {};
  commentLength = 0;
  isLoading = false;
  feedbackTypes = [
    `General`,
    `Technical issues`,
    `Permit form issues`,
    `Purchase issues`,
    `Email issues`,
    `Load Tag issues`
  ];

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly viewPortScroller: ViewportScroller,
    public applicationService: PermitsService,
    private winRef: WindowRef,
    private readonly feedbackService: FeedbackService,
    private readonly modalService: ModalService
  ) {
  }

  ngOnInit() {
    this.viewPortScroller.scrollToPosition([0, 0]);
    this.initForm();
  }

  initForm() {
    this.feedbackForm = this.formBuilder.group({
      type: [null, Validators.required],
      first_name: [null, [Validators.required, Validators.maxLength(50), Validators.pattern(/^[a-zA-Z0-9\-.\, ()/|]*$/)]],
      last_name: [null, [Validators.required, Validators.maxLength(50), Validators.pattern(/^[a-zA-Z0-9\-.\, ()/|]*$/)]],
      email_address: [null, [Validators.required, Validators.maxLength(50), Validators.email, Validators.pattern(CustomValidators.emailPattern)]],
      subject: [null, [Validators.required, Validators.maxLength(50)]],
      responseWanted: [null],
      comments: [null, [Validators.required, Validators.maxLength(1000)]],
    }, {
      validators: []
    })
  }

  commentChanged(comment: string) {
    if (!comment || !comment.length) {
      this.commentLength = 0;
    } else {
      this.commentLength = comment.length;
    }
  }

  submit() {
    const data: FeedbackDto = new FeedbackDto(this.feedbackForm.value);

    this.isLoading = true;
    this.feedbackService.sendEmail(data).subscribe((result: any) => {
      this.showSuccessModal();
      this.isLoading = false;
      this.resetForm();
    });
  }

  showSuccessModal() {
    const modalConfig = {
      title: 'Your Feedback Has Been Received',
      body: 'If you requested a response to your comment, we will reply as soon as possible',
      closeButtonText: 'Close',
    };
    this.modalService.open(modalConfig);
  }

  resetForm() {
    this.feedbackForm.reset();
  }
}
